
import { CustomMenu } from "../../../../../common/domain/modelos/menu/CustomMenu";
import store from "../../../../../common/infrastructure/almacen";
import { Actions, Mutations } from "../../../../../common/infrastructure/almacen/enums/StoreEnums";
import { CookieService } from "../../../../../common/infrastructure/servicios";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";

import { IServiceUserOption } from "../../../user/application/IServiceUserOption";
import { IapmUserOption } from "../../../user/domain/iapmUserOption";
import { TYPES } from "../../../../../common/domain/types";
import { ref } from "vue";

//import { AppLayoutConfig } from "../../../../builder/template/infrastructure/prime/AppLayoutConfig"
//import AppLayoutBuilder from "../../../../builder/template/infrastructure/prime/AppLayoutBuilder"
import { useLayoutBuilder } from '../../../../builder/template/infrastructure/prime/LayoutBuilder'
import { Container } from "inversify";

//import { debug } from "console";
//import { IapApplicationConfiguration } from "../../../../builder/application/domain/iapApplicationConfiguration";
//import { IapCatalog } from "../../../../builder/catalog/domain/iapCatalog";

const { getAppLayoutConfig, changeAppTemplate} = useLayoutBuilder();

function getApplicationMenus(fromShared: boolean, routes: any, applicationId: number, applicationVersion:number, container: Container, routeToRedirect: string): void {
  
  store
    .dispatch(Actions.SET_MENU, [applicationId, applicationVersion, container])
    .then(() => {
      //visibleRight.value = false;      
      buildRoutes(fromShared, routes, container, store.getters.getApplicationMenus, -1);      
      store.dispatch(Actions.SET_ROUTES, routes)
    })
    .finally(() => {
      if (routeToRedirect == '') {
        redirectCompleteLogin(routes);
      }
      else {
        routes.push({ name: routeToRedirect });
      }
    });

    getAppConfigTemplate(applicationId, applicationVersion, container);
}


async function getAppConfigTemplate (applicationId: number, applicationVersion:number, container: Container) : Promise<void> {
  var appUserLayoutOptions:IapmUserOption[] = []
  var user = store.getters.getCurrentUser

  if (user.iapmUserOptions.length == 0) {
    const _srvUsrOpt = container?.get<IServiceUserOption>(TYPES.USER_OPTION_SERVICE);
    await _srvUsrOpt?.getFilteredUserOptions(applicationId, applicationVersion, user.id, 'AppLayout')
      .then((response: any) => {
        appUserLayoutOptions = response;
      })
      .finally(() => {
      });
  } else {
    appUserLayoutOptions = user.iapmUserOption
  }

  // Se añade la configuración del Template del Usuario al storage
  getAppLayoutConfig(appUserLayoutOptions);

}


/*
En el menu el campo 'route' es la ruta de componentes estaticos 
*/
const buildRoutes = (fromShared: boolean, routes: any, container: Container, menusBuilder: CustomMenu[], parentId: -1, parentLabel: string | null = null) => {
  
  if (menusBuilder?.length > 0) {
    menusBuilder
      .filter(
        (x) =>
          (parentId == -1 && x.parentId == null) ||
          (parentId !== -1 && x.parentId == parentId)
      )
      .sort((x) => x.order ?? 0)
      .forEach((menu) => {
        if ((menu.to?.toString()) || menu.componentId != null) {
          //********* En el menu el campo 'route' es la ruta de componentes estaticos  ******************
          const menuRoute = (menu.route?.toString() ?? 'EmptyPage.vue')
          let componentaux = getComponentFromShared(menu.componentId, menuRoute);

          if (!fromShared) {
            componentaux = getComponentFromOutsideShared(menu.componentId,menuRoute);
          }
          const route = {
            path: menu.to?.toString() ,
            force:true,
            name:
              menu.to != null && menu.to != undefined
                ? menu.to.toString().replace("/", "")
                : "",
            meta: {
              breadcrumb: [
                {
                  parent: menu.to?.toString() && menuRoute ? parentLabel : null,
                  label:menu.label,
                },
              ],
              directivas: "",
              builtin: "",
              contrato: menu.contract,
            },
            component: componentaux,
            props: {
              container: container,
              componentId: menu.componentId,
              applicationId: menu.applicationId,
              applicationVersion: menu.applicationVersion,
            },
          }

          routes?.addRoute(route);

        }
        buildRoutes(fromShared, routes, container, (menu.items as CustomMenu[] ?? []), menu.id as any, (parentLabel == null ? '' : (parentLabel + ' > ') ) + menu?.label as any);
      });
  }
};

function getComponentFromShared(componentId: number | null, route: string) {

  if (componentId != null) {

    return import("../../../../builder/form/infrastructure/FormBuilder.vue");
  }

  switch (route) {
    case '../../../../builder/application/infrastructure/component/Applications.vue':
      return import('../../../../builder/application/infrastructure/component/Applications.vue');
    case '../../.././../builder/designer/infrastructure/component/Container.vue':
      return import('../../../../builder/designer/infrastructure/component/Designer.vue');

    case "../../../../otros/inicio/mipanel/infrastructure/MiPanel.vue":
      return import(
        "../../../../otros/inicio/mipanel/infrastructure/MiPanel.vue"
      );
    case "EmptyPage.vue":
        return import('../../../../../common/infrastructure/EmptyPage.vue');
    default:
      return import(route);
  }
}

function getComponentFromOutsideShared(componentId: number | null, route: string) {
  if (componentId != null) {
    return import("@ilinium/shared/src/entidades/builder/form/infrastructure/FormBuilder.vue");
  }

  switch (route) {
    case '../../../../builder/application/infrastructure/component/Applications.vue':
      return import('@ilinium/shared/src/entidades/builder/application/infrastructure/component/Applications.vue');
    case '../../.././../builder/designer/infrastructure/component/Container.vue':
      return import('@ilinium/shared/src/entidades/builder/designer/infrastructure/component/Designer.vue');

     case "../../../../otros/inicio/mipanel/infrastructure/MiPanel.vue":
      return import(
        "@ilinium/shared/src/entidades/otros/inicio/mipanel/infrastructure/MiPanel.vue"
      );

      case "EmptyPage.vue":
        return import('@ilinium/shared/src/common/infrastructure/EmptyPage.vue');
    default:
      return import(route);
  }
}

function redirectCompleteLogin(routes: any) {
  var redirectCookie = CookieService.getCookie(
    CookieService.COOKIE_REDIRECT_URL
  );
  if (redirectCookie != null && redirectCookie != "") {
    routes?.push({ name: redirectCookie });
  } else {
    /* var cookieDobleFactor = CookieService.getCookie(CookieService.COOKIE_DOBLEFACTOR);

          
          if ((!store.getters.getCurrentUser.configuraciones.configuraciones.find((c: { idClave: string }) => c.idClave == 'cfgbroker-MFA')?.valor)
          ||
              ((cookieDobleFactor != null && cookieDobleFactor != '') &&
              store.getters.getCurrentUser.configuraciones.configuraciones.find((c: { idClave: string }) => c.idClave == 'cfgbroker-MFA')?.valor &&
              store.getters.getCurrentUser.usuarioDobleAutenticacion != null &&
              store.getters.getCurrentUser.usuarioDobleAutenticacion.codigo != null &&
              store.getters.getCurrentUser.usuarioDobleAutenticacion.codigo != '' &&
              store.getters.getCurrentUser.usuarioDobleAutenticacion.fechaCaducidadDobleAuth != null &&
              (new Date(store.getters.getCurrentUser.usuarioDobleAutenticacion.fechaCaducidadDobleAuth) >= new Date()) &&
              store.getters.getCurrentUser.usuarioDobleAutenticacion.validado)) 
              
              {
                  */

    var initUrl = store.getters.initUrlPage;
    if (initUrl == "") {
      const id = HelperUtils.newGuid();
      routes?.push({
        name: "rfps",
        params: { id: id, operation: "productos" },
      });
    } else {
      routes?.push({
        name: /*initUrl == 'default.aspx' ? */ "mipanel" /* : initUrl*/,
      });
    }
    /*}
          else {
              showModalAuthType.value = true;
          }
          */
  }
}


export default {
  getApplicationMenus
}